import React, { useEffect, useRef, useState } from "react";

function AnimatedCounter({ end, duration = 600, start = 0 }) {
    const [count, setCount] = useState(start);
    const [hasAnimated, setHasAnimated] = useState(false);
    const ref = useRef();

    useEffect(() => {
        let observer;
        let animationFrame;

        const animate = () => {
            let startTimestamp = null;
            const step = (timestamp) => {
                if (!startTimestamp) startTimestamp = timestamp;
                const progress = Math.min((timestamp - startTimestamp) / duration, 1);
                setCount(Math.floor(progress * (end - start) + start));
                if (progress < 1) {
                    animationFrame = requestAnimationFrame(step);
                } else {
                    setCount(end);
                }
            };
            requestAnimationFrame(step);
            setHasAnimated(true);
        };

        if (ref.current) {
            observer = new window.IntersectionObserver(
                ([entry]) => {
                    if (entry.isIntersecting && !hasAnimated) {
                        animate();
                    }
                    // Reset for future animations if you want to re-animate every time
                    if (!entry.isIntersecting && hasAnimated) {
                        setCount(start);
                        setHasAnimated(false);
                    }
                },
                { threshold: 0.5 }
            );
            observer.observe(ref.current);
        }

        return () => {
            if (observer && ref.current) observer.unobserve(ref.current);
            if (animationFrame) cancelAnimationFrame(animationFrame);
        };
    }, [end, duration, start, hasAnimated]);

    return (
        <span ref={ref}>{count}</span>
    );
}

export default AnimatedCounter;